import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { ContextService } from '../../services/context.service';
import { RoleService } from '@ind4.0/angular-common-lib';
@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrl: './left-menu.component.scss',
  standalone: false,
})
export class LeftMenuComponent implements OnInit {
  subMenuOpened: number | null = null;
  model: any[] = [];
  private roleService = inject(RoleService);

  private readonly allNavigationItems = [
    { label: 'Usines', iconClass: 'pi pi-warehouse', route: '/factory' },
    {
      label: 'Vue poste de travail',
      iconClass: 'pi pi-th-large',
      route: '/work-center-view',
    },
    // { label: 'Support', iconClass: 'pi pi-question-circle', route: '/support' },
    {
      label: 'Maintenance',
      iconClass: 'pi pi-wrench',
      route: '/coordinator',
      requiredRole: 'SED_PLUS_SUPER_USER',
    },
    {
      label: 'Tableau de bord KPI',
      iconClass: 'pi pi-chart-bar',
      route: '/kpi-dashboard',
    },
  ];

  navigationItems: any[] = [];

  constructor(
    public context: ContextService,
    public el: ElementRef,
  ) {}

  ngOnInit(): void {
    this.navigationItems = this.allNavigationItems.filter(
      (item) =>
        !item.requiredRole || this.roleService.hasRole(item.requiredRole),
    );
  }
}
